import { useEffect, useState } from "react";
import { CloudOff, CheckCircle2, Loader2 } from "lucide-react";
import { onQueueChange, peek, sync } from "../lib/offlineQueue";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

function apiFetch(path, options = {}) {
    const token = localStorage.getItem("token");
    return fetch(BACKEND + path, {
        ...options,
        headers: {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : undefined,
            ...(options.headers || {}),
        },
    });
}

export default function SyncPill() {
    const [pending, setPending] = useState(0);
    const [online, setOnline] = useState(navigator.onLine);
    const [syncing, setSyncing] = useState(false);

    useEffect(() => {
        peek().then((items) => setPending(items.length));
        const off = onQueueChange(({ pending }) => setPending(pending));
        const onOnline = () => { setOnline(true); triggerSync(); };
        const onOffline = () => setOnline(false);
        window.addEventListener("online", onOnline);
        window.addEventListener("offline", onOffline);
        // periodic sync tick
        const t = setInterval(() => { if (navigator.onLine) triggerSync(); }, 15000);
        return () => {
            off();
            window.removeEventListener("online", onOnline);
            window.removeEventListener("offline", onOffline);
            clearInterval(t);
        };
    }, []);

    async function triggerSync() {
        setSyncing(true);
        try { await sync(apiFetch); } catch {}
        setSyncing(false);
    }

    if (online && pending === 0 && !syncing) {
        return (
            <span className="hidden sm:inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200" data-testid="sync-pill" title="All changes synced">
                <CheckCircle2 className="w-3 h-3" /> synced
            </span>
        );
    }
    if (!online) {
        return (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-amber-50 text-amber-700 border border-amber-200" data-testid="sync-pill" title="Offline — actions queued locally">
                <CloudOff className="w-3 h-3" /> offline · {pending} pending
            </span>
        );
    }
    return (
        <button onClick={triggerSync} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-[#F4F6F9] text-[#1E3355] border border-gray-200 hover:bg-white" data-testid="sync-pill" title="Retry now">
            {syncing ? <Loader2 className="w-3 h-3 animate-spin" /> : <Loader2 className="w-3 h-3" />} syncing · {pending} pending
        </button>
    );
}
